import { APIMethod, ApiService } from 'src/app/shared/services/api.service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { APIRequest } from 'src/app/shared/models/apirequest.model';
import { Download } from 'src/app/shared/models/DownloadModel';
@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private apiservice: ApiService) {}

  DownloadOriginal(FileID: number, download: Download, type: string) {
    {
      const apiRequest: APIRequest = new APIRequest(
        'Data/DownloadOriginalFile?' + '&fileID=' + FileID,
        APIMethod.GET
      );
      return this.apiservice.executeAPI(apiRequest).pipe(
        map(response => {
          if (response.isSuccess) {
            apiRequest.DownloadFile(response, type, download);
          }
          return response;
        })
      );
    }
  }

  DownloadFailedRecordsFile(FileID: number, download: Download, type: string) {
    {
      const apiRequest: APIRequest = new APIRequest(
        'Data/GetFailedRecordByFileID?' + '&fileID=' + FileID,
        APIMethod.GET
      );
      return this.apiservice.executeAPI(apiRequest).pipe(
        map(response => {
          if (response.isSuccess) {
            download.FileName = response.result.fileDownloadName;
            apiRequest.DownloadFile(response, type, download);
          }
          return response;
        })
      );
    }
  }

  DownloadRatedFile(FileID: number, download: Download, type: string) {
    {
      const apiRequest: APIRequest = new APIRequest(
        'Data/DownloadRatedFile?' + '&fileID=' + FileID,
        APIMethod.GET
      );
      return this.apiservice.executeAPI(apiRequest).pipe(
        map(response => {
          if (response.isSuccess) {
            download.FileName = response.result.fileDownloadName;
            apiRequest.DownloadFile(response, type, download);
          }
          return response;
        })
      );
    }
  }

  DownloadUserGuide(download: Download, type: string) {
    const apiRequest: APIRequest = new APIRequest(
      `Data/DownloadUserGuide`,
      APIMethod.GET
    );
    this.apiservice.executeAPI(apiRequest).subscribe(response => {
      download.FileName = response.result.fileDownloadName;
      apiRequest.DownloadFile(response, type, download);
    });
  }
}
